export default {"src":"/_next/static/media/phishing-simulation.b93adbb6.svg","height":286,"width":286,"blurWidth":0,"blurHeight":0};